export default "__VITE_ASSET__7f9b7e04__"